<template lang="pug">
.content(:class="[{ 'is-sortable': edit && sortable, 'is-deletable': deletable, 'is-restorable': content.deleted }, contentSettings.type, config.key]")
    h4.handle(v-if="edit && sortable")
        //- span.el-icon-fa-sort.fas
        span.icon.sort
            svg(xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6")
              path(stroke-linecap="round" stroke-linejoin="round" d="M3.75 5.25h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5" )
    .fields
        .deprecation-notice(v-if="edit && isDeprecated")
            i.el-icon-fa-triangle-exclamation.fas
            span {{ $t('deprecated-field-notice') }}
        .field(
            v-for="field in fields" :key="field.key"
            v-if="config.fields && config.fields.length && checkConditions(field)"
            :class="[field.key, { edit, deleted: content.deleted }]"
        )
            image-content(
                v-if="field.key == 'images'"
                :section="section"
                :content="content"
                :config="config"
                :options="options"
                :section-settings="sectionSettings"
                :section-setting-values="sectionSettingValues"
                :edit="edit"
            )
            form-input-field(
                v-else
                :section="section"
                :content="content"
                :config="field"
                :options="options"
                :section-settings="sectionSettings"
                :section-setting-values="sectionSettingValues"
                :settings="config.settings"
                :edit="edit"
            )
    .actions(v-if="deletable || content.deleted")
        el-button.restore-content(
            v-if="content.deleted"
            circle type="info" size="mini"
            icon="el-icon-fa-trash-restore fas"
            @click.prevent.stop="restoreContent(content.id)"
        )
        el-button.delete-content(
            v-else-if="deletable"
            circle type="danger" size="mini"
            icon="el-icon-fa-trash-alt far"
            @click.prevent.stop="deleteContent(content.id)"
        )
</template>

<i18n>
{
    "en": {
        "Field #{nr}": "Field #{nr}",
        "deprecated-field-notice": "Deprecated – this field no longer affects the email. The email content is now controlled by the document template. You can remove this field."
    },
    "de": {
        "Field #{nr}": "{nr}. Formularfeld",
        "Heading": "Überschrift",
        "Text": "Text",
        "Email content": "Email Inhalt",
        "deprecated-field-notice": "Veraltet – dieses Feld hat keine Auswirkung mehr auf die E-Mail. Der E-Mail-Inhalt wird jetzt über die Dokumentvorlage gesteuert. Sie können dieses Feld entfernen."
    }
}
</i18n>

<script>

import _ from 'lodash'

import FormInputField from './InputField'
import InputContent from '@/components/Page/Sections/Partials/InputContent'
import ImageContent from '@/components/Page/Sections/Partials/ImageContent'

export default {
    name: 'InputContent',
    extends: InputContent,
    components: {
        FormInputField,
        ImageContent,
    },
    computed: {
        // email-intro / email-content are legacy: they still render on existing
        // forms but no longer affect the email (the body is now driven by the
        // "Kontaktformular-Benachrichtigung" document template).
        isDeprecated() {
            return this.config.key === 'email-intro'
                || (this.contentSettings && this.contentSettings.type === 'email-content')
        },
        sendCopyEnabled() {
            const value = _.get(this.sectionSettingValues, 'send-copy-to')
            return ['true', '1', 'yes', true].includes(value)
        },
        // Email is the address the confirmation copy is sent to, so it is locked
        // (non-deletable) ONLY while "send a confirmation copy to the submitter"
        // is enabled. Name and legacy email-intro blocks are always removable;
        // everything else falls back to the base (min-based) behaviour.
        deletable() {
            if (!this.edit) return false

            const key = this.config.key
            if (key === 'user-email') return !this.sendCopyEnabled
            if (['user-name', 'email-intro'].includes(key)) return true

            const min = _.get(this.config, 'min')
            const contents = this.section.contents.filter(content => !content.deleted)
            return min !== null && min < contents.length
        },
        fields() {
            let fields = _.cloneDeep(this.config.fields) || []

            if (this.contentSettings && this.contentSettings.type === 'email-content') {
                let title = fields.find(el => el.key === 'title')
                if (title) {
                    title.name = this.$t('Email content')
                    title.placeholder = this.$t('Heading')
                }

                fields.push({
                    key: 'text',
                    // name: this.$t('Email content'),
                    placeholder: this.$t('Text'),
                    type: 'rte',
                })
            }

            return fields
        }
    },
}
</script>

<style lang="sass" scoped>
.deprecation-notice
    display: flex
    align-items: flex-start
    margin-bottom: 16px
    padding: 8px 12px
    border-radius: 4px
    background: #fdf6ec
    border: 1px solid #faecd8
    color: #b88230
    font-size: 13px
    line-height: 1.4
    i
        margin-top: 2px
        margin-right: 8px
        flex-shrink: 0

.field.edit
    margin-bottom: 22px
    transition: opacity .15s ease
    &.deleted
        opacity: .5
        pointer-events: none
        ::v-deep *
            pointer-events: none

.content
    display: grid
    grid-template-columns: auto
    border-left: none !important
    transition: background .3s ease
    margin-bottom: 1rem
    &.is-deletable
        grid-template-columns: auto max-content
    &.is-sortable
        grid-template-columns: 30px auto
        &.is-deletable
            grid-template-columns: 30px auto max-content
    ::v-deep
        .el-switch:not(.is-checked) .el-switch__core
            background: rgba(0,0,0,.2)
    button.delete-content,
    button.restore-content
        transition: none

.actions,
.handle
    // display: flex
    // align-items: center
    // justify-content: center
    padding-top: 26px
    margin-top: 0

.actions
    margin-left: 1rem

.handle
    color: $color-grey-text
    opacity: .6

.drawer-body
    .email-content, .email-intro
        color: white
        // background: repeating-linear-gradient(-45deg, rgba(0,0,0,0), rgba(0,0,0,0) 12px, rgba(255,255,255,.3) 12px, rgba(255,255,255,.3) 24px)
        // background-image: repeating-linear-gradient(-45deg, transparent, transparent 2px, #f5f5f5 2px, #f5f5f5 21px)
        // background-image: repeating-linear-gradient(-45deg, transparent, transparent 2px, rgba(255,255,255,.4) 2px, rgba(255,255,255,.4) 21px)
        background-image: repeating-linear-gradient(-45deg, transparent, transparent 2px, rgba($--color-primary, 0.15) 2px, rgba($--color-primary, 0.15) 21px)
        background-size: 30px 60px
        // background: rgba(255,255,255,.7)
        margin-left: -20px
        padding-left: 20px
        margin-right: -20px
        padding-right: 20px
        margin-top: -10px
        padding-top: 10px
        &.is-deletable .positioning-container
            padding-right: 36px !important
            button.delete-content,
            button.restore-content
                right: 0px !important
                top: 28px !important
        span
            // & > .field:first-child
            //     margin-bottom: 5px
            & > .field:last-child
                margin-bottom: 0
        // ::v-deep
        //     .setting.required
        //         display: none
</style>
